import { useSelector } from 'react-redux'

import { botFlowSelector } from '../selectors/botFlowSelector'

export function useBotFlow() {
  return useSelector(botFlowSelector)
}
